// Angular Files
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Angular Material
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyListModule } from '@angular/material/legacy-list';

// Component Files
import { TellerOnlineScheduledPaymentDetailsComponent } from './scheduled-payment-details.component';

@NgModule({
    declarations: [TellerOnlineScheduledPaymentDetailsComponent],
    imports: [
        CommonModule,
        MatDividerModule,
        MatLegacyTooltipModule,
        MatLegacyListModule
    ],
    exports: [TellerOnlineScheduledPaymentDetailsComponent]
})
export class TellerOnlineScheduledPaymentDetailsModule { }
